import { api } from "../../api/client";

export function getUsers() {
  return api.get("/admin/users");
}

export function createUser(user) {
  return api.post("/admin/users", user);
}

export function deleteUser(userId, sessionId) {
  return api.delete(`/admin/users/${userId}`, { data: { session_id: sessionId } });
}
